export const URBANICA_INTEGRATION_CLASS = 'UrbanicaCustom';
